module.exports = __webpack_public_path__ + "img/step2.91d3cf2c.svg";